import Om from "./components/Om";
import Kontakt from "./components/Kontakt";
import Artikler from "./components/Artikler";
import Forside from "./components/Forside";
import Services from "./components/Services";
import Products from "./components/Products";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BusinessController from "./components/BusinessController";
import BusinessPartner from "./components/BusinessPartner";
import BusinessAnalysis from "./components/BusinessAnalysis";
import Layout from './components/Layout';
import AarticleExcel1SimpleMacros from "./components/AArticleExcel1SimpleMacros";
import AArticleSQLBeginner from "./components/AArticleSQL1BeginnerSQL";
import AAticleFitnessEconomy from "./components/AAticleFitnessEconomy";
import AArticleTheDashboard from "./components/AArticleTheDashboard";
import AAticleBusinessPartnering from "./components/AAticleBusinessPartnering";
import AAticleBusinessControlling from "./components/AAticleBusinessControlling";
import AArticleAutoVarianceAnalysis from "./components/AArticleAutoVarianceAnalysis";
import AArticleAutoDataConsolidation from "./components/AArticleAutoDataConsolidation";
import AArticleMLforecast from "./components/AArticleMLforecast";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={
            <>
              <Forside />
              <Om />
              <Services />
              <Products />
              <Artikler />
              <Kontakt />
            </>
          } />
          <Route path="/business-controller" element={
            <>
              <BusinessController />
            </>
          } />
          <Route path="/business-partner" element={
            <>
              <BusinessPartner />
            </>
          } />
          <Route path="/excel-articles/SimpleMacros" element={
            <>
              <AarticleExcel1SimpleMacros />
            </>
          } />
          <Route path="/SQL-articles/Beginner" element={
            <>
              <AArticleSQLBeginner />
            </>
          } />
          <Route path="/Random-articles/Fitness" element={
            <>
              <AAticleFitnessEconomy />
            </>
          } />
          <Route path="/PowerBI-articles/TheDashboard" element={
            <>
              <AArticleTheDashboard />
            </>
          } />
          <Route path="/Business-articles/BusinessPartnering" element={
            <>
              <AAticleBusinessPartnering />
            </>
          } />
          <Route path="/Business-articles/BusinessControlling" element={
            <>
              <AAticleBusinessControlling />
            </>
          } />
          <Route path="/Python-articles/AutoVarianceAnalysis" element={
            <>
              <AArticleAutoVarianceAnalysis />
            </>
          } />
          <Route path="/Python-articles/AutoDataConsolidation" element={
            <>
              <AArticleAutoDataConsolidation />
            </>
          } />
          <Route path="/Python-articles/MLforecast" element={
            <>
              <AArticleMLforecast />
            </>
          } />
          <Route path="/business-analysis" element={
            <>
              <BusinessAnalysis />
            </>
          } />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
